import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';
import { primitive } from 'styles/constants/primitives';

export const LoyaltyTransactionCardSkeleton = () => {
  const numColumns = 3;
  const numTransactions = 4;

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        {Array.from({ length: numColumns }).map((_, i) => (
          <Skeleton key={i} shape="rectangle" style={{ width: 87, height: 16 }} />
        ))}
      </View>
      <View style={styles.content}>
        {Array.from({ length: numTransactions }).map((_, i) => (
          <View style={styles.transaction} key={i}>
            <Skeleton shape="rectangle" style={{ height: 25, borderRadius: 12 }} />
          </View>
        ))}
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.$2,
    borderWidth: 1,
    borderColor: primitive.$blackOpacity10,
    borderRadius: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: spacing.$12,
    borderBottomWidth: 1,
    borderColor: primitive.$blackOpacity10,
    paddingVertical: spacing.$2,
  },
  content: {},
  transaction: {
    padding: spacing.$4,
    borderBottomWidth: 1,
    borderColor: primitive.$blackOpacity10,
  },
});
